export async function fetchUser(user) {
    try {
        //const users = user.phoneNumber;
       //console.log("api 1 : ", user);
      const response = await fetch('https://yesedacademy.com/database/userProfile.php', {
        method: 'POST',
        body: JSON.stringify({ user}),
        headers: {
          'Content-Type': 'application/json',
        },
        
      });
     console.log('emaill : ', user);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
  
      const details = await response.json();
      return details;
    } catch (error) {
      throw new Error('Error fetching user data:', error);
    }
  }

 